import React from 'react';
export var isComponent = function isComponent(instance) {
  return (
    // In case of pure html elements type is a string that represent the tag name ('div', 'p', 'span', ...)
    /*#__PURE__*/
    React.isValidElement(instance) && (typeof instance.type === 'object' || typeof instance.type === 'function')
  );
};